import mReportColumn from "@/models/mReportColumn";
import formatter from "@/utilities/Formatter";
import UtilsData from "@/utilities/UtilsData";

export default {
  // ##################################################
  formatColValue(value, dbName, columnFormatters) {
    let res = value;
    let autoDefine = true;
    // #####
    let func = null;
    let funcParams = [];
    const formatSettings = this.findFormatSettings(dbName, columnFormatters);
    if (formatSettings) {
      autoDefine = false;
      if (formatSettings.hasOwnProperty('func')) {
        func = formatSettings.func;
      }
      if (formatSettings.hasOwnProperty('funcParams')) {
        funcParams = formatSettings.funcParams;
      }
      if (func) {
        funcParams.unshift(value);
        if (formatter[func]) {
          res = formatter[func].apply(this, funcParams);
        }
      }
    }
    // #####
    if (autoDefine) {
      res = isNaN(value) ? value : formatter.formatDollarValue(value, 2)
    }
    if (value === null || value === 'null') {
      res = ''
    }
    if (value === true || value === 'true') {
      res = 'true'
    }
    if (value === false || value === 'false') {
      res = 'false'
    }
    return res;
  },
  formatColClasses(dbName, value, columnFormatters) {
    let res = '';
    let autoDefine = true;
    const formatSettings = this.findFormatSettings(dbName, columnFormatters);
    if (formatSettings) {
      if (formatSettings.hasOwnProperty('classes')) {
        res = res + ' ' + formatSettings.classes;
        autoDefine = false;
      }
    }
    // #####
    if (autoDefine) {
      if (UtilsData.isNumber(value)) {
        res = ` ${res} text-right`;
      }
    }
    if (value && value.toString) {
      let v = value.toString();
      if (v.length <= 20) {
        res = ` ${res} text-nowrap`;
      }
    }
    // #####
    return res;
  },
  formatColName(dbName, columnFormatters) {
    let res = dbName;
    const objColSettings = this.findColSettings(dbName, columnFormatters);
    if (objColSettings) {
      res = objColSettings.Name;
    }
    return res;
  },
  // ##################################################
  isFieldInTotals(dbName, columnFormatters) {
    const colSettings = this.findColSettings(dbName, columnFormatters)
    if (colSettings) {
      if (colSettings.Total) {
        return Boolean(colSettings.Total);
      }
    }
    return false;
  },
  // ##################################################
  findColSettings(dbName, columnFormatters) {
    let res = columnFormatters.find(el => el.DbName === dbName);
    return res;
  },
  findFormatSettings(dbName, columnFormatters) {
    let res = null;
    const objColSettings = this.findColSettings(dbName, columnFormatters);
    if (objColSettings) {
      const vocDataTypeFormat = mReportColumn.vocDataTypeFormat()
      res = vocDataTypeFormat[objColSettings.DataType];
    }
    return res;
  }
  // ##################################################
}
